import axios from 'axios'
import { httpNotification } from '../notification'
const instace = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json'
  },
  responseType: 'blob'
})

instace.interceptors.request.use(
  config => {
    // config.params = paramInterceptors(config);
    const token = localStorage.getItem('token')

    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  error => Promise.reject(error)
)
const getReportsXls = async query => {
  try {
    const response = await instace.get(`/relatorios/acervo/excel?${query}`, {
      id_biblioteca: 1
    })
    return response
  } catch (err) {
    const validations = err.response.data.data
    for (const msg in validations) {
      if (typeof validations[msg] === 'string') {
        httpNotification('error', 'get', validations[msg])
      }
      if (typeof validations[msg] === 'object') {
        validations[msg].forEach(err => {
          httpNotification('error', 'get', err)
        })
      }
    }
    return err?.response || err
  }
}

export default getReportsXls
